<!--
	Lists the MUTCD alignment sign images with their recommendation level.
-->
<script lang="ts">
	import type { TSignageProvision } from '@safesystem/client-playbook-lib';
	import { SIGN_LEVELS } from '../legends/signImages';

	interface Props {
		signageProvision: TSignageProvision;
	}

	const { signageProvision }: Props = $props();

	const rows = $derived(
		SIGN_LEVELS.filter(
			([label]) => signageProvision[label.toLowerCase() as Lowercase<typeof label>]
		)
	);
</script>

<ul class="signs">
	{#each rows as [label, image] (label)}
		<li>
			<img src={image} alt="" />
			{label}
		</li>
	{/each}
</ul>

<style>
	.signs {
		margin: var(--space-4) var(--space-4) 0 var(--space-1);
		padding: 0;
		list-style: none;

		li {
			display: flex;
			align-items: center;
			gap: var(--space-4);
			border-top: 2px solid var(--border-color);
			padding: var(--space-2) var(--space-2) var(--space-1);
		}

		img {
			width: 1.7rem;
		}
	}
</style>
